/**
 * Device ID helper (web).
 *
 * Gera um UUID na primeira chamada e persiste em localStorage. Retorna o
 * mesmo ID em chamadas subsequentes, sobrevivendo a logout e reload.
 *
 * IMPORTANTE: a chave `deviceId` NÃO deve ser removida em nenhum fluxo de
 * logout. Hoje (2026-04-21) os caminhos de logout validados são:
 *   - modules/auth/services/auth.service.ts — remove auth_token/refresh_token apenas
 *   - lib/api.ts (auto-logout)              — remove auth_token apenas
 *   - lib/clearUserFilters.ts               — remove chaves de filtros, não toca em deviceId
 *
 * Se um novo fluxo de logout for adicionado, NÃO incluir a chave `deviceId`
 * na limpeza — isso quebra a dedupe de push notifications do backend.
 */

const STORAGE_KEY = 'deviceId';

export function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}
